import React from 'react';
import './OutlinedTextButton.scss';

const OutlinedTextButton = props => (
    <button className={`co-btn-text-outline ${props.className ? props.className : ""}`} onClick={props.onClick}>
        {props.text}
    </button>
);

export default OutlinedTextButton;